import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ErrorDisplayComponent } from '../error-display/error-display.component';

@Component({
  selector: 'rn-form-input-state-control',
  templateUrl: './form-input-state-control.component.html',
  styleUrls: ['./form-input-state-control.component.scss'],
  imports: [CommonModule, ErrorDisplayComponent],
  standalone: true,
})
export class FormInputStateControlComponent implements OnInit {
  @Input() formReference: UntypedFormControl;
  @Input() isError?: boolean;
  @Input() customMessage?: string;
  @Input() showCharacterCount?: boolean;
  @Input() totalLength?: number;

  ngOnInit(): void {}
}
